import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async (params, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.personal.kpiStatistics, { ...params }, options);
    if (error) return { error, status };
    return content || {
        projKpiCount: 0, // 项目绩效表数
        projKpiMonitorCount: 0, // 项目绩效监控数
        depCount: 0, // 部门数
    };
};
